"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testSingleNumberEffectiveDefinition = exports.getConstantSingleNumberEffectiveDefinition = exports.testEffectiveDefinition = exports.getConstantEffectiveDefinition = void 0;
var comparison_1 = require("./features/comparison");
var metricValue_1 = require("./features/metricValue");
var models_1 = require("./models");
var constantEffectiveDefinition = {
    schema: {
        measure: {
            type: 'number',
            name: metricValue_1.MEASURE_COLUMN_NAME,
        },
        timestamp: {
            type: 'datetime',
            name: metricValue_1.TIMESTAMP_COLUMN_NAME,
            dateGranularity: models_1.DateGranularity.DAY,
        },
        color: {
            type: 'string',
            name: 'color',
        },
        comparisonMeasure: {
            type: 'number',
            name: comparison_1.COMPARISON_MEASURE_COLUMN_NAME,
        },
        comparisonTimestamp: {
            type: 'datetime',
            name: comparison_1.COMPARISON_TIMESTAMP_COLUMN_NAME,
        },
    },
    features: {
        color: {
            column: 'color',
        },
        measure: { column: metricValue_1.MEASURE_COLUMN_NAME },
        timestamp: { column: metricValue_1.TIMESTAMP_COLUMN_NAME },
        threshold: {
            thresholds: [
                {
                    lines: [
                        {
                            measure: { column: comparison_1.COMPARISON_MEASURE_COLUMN_NAME },
                            timestamp: { column: comparison_1.COMPARISON_TIMESTAMP_COLUMN_NAME },
                        },
                    ],
                },
            ],
        },
    },
};
var getConstantEffectiveDefinition = function () {
    return constantEffectiveDefinition;
};
exports.getConstantEffectiveDefinition = getConstantEffectiveDefinition;
exports.testEffectiveDefinition = (0, exports.getConstantEffectiveDefinition)();
var constantSingleNumberEffectiveDefinition = {
    schema: {
        measure: {
            type: 'number',
            name: metricValue_1.MEASURE_COLUMN_NAME,
        },
        timestamp: {
            type: 'datetime',
            name: metricValue_1.TIMESTAMP_COLUMN_NAME,
            dateGranularity: models_1.DateGranularity.DAY,
            isSnapshotTimestamp: true,
        },
        color: {
            type: 'string',
            name: 'color',
        },
        comparisonMeasure: {
            type: 'number',
            name: comparison_1.COMPARISON_MEASURE_COLUMN_NAME,
        },
        comparisonTimestamp: {
            type: 'datetime',
            name: comparison_1.COMPARISON_TIMESTAMP_COLUMN_NAME,
        },
    },
    features: {
        color: {
            column: 'color',
        },
        measure: { column: metricValue_1.MEASURE_COLUMN_NAME },
        timestamp: { column: metricValue_1.TIMESTAMP_COLUMN_NAME },
        threshold: {
            thresholds: [
                {
                    lines: [
                        {
                            measure: { column: comparison_1.COMPARISON_MEASURE_COLUMN_NAME },
                            timestamp: { column: comparison_1.COMPARISON_TIMESTAMP_COLUMN_NAME },
                        },
                    ],
                },
            ],
        },
    },
};
var getConstantSingleNumberEffectiveDefinition = function () {
    return constantSingleNumberEffectiveDefinition;
};
exports.getConstantSingleNumberEffectiveDefinition = getConstantSingleNumberEffectiveDefinition;
exports.testSingleNumberEffectiveDefinition = (0, exports.getConstantSingleNumberEffectiveDefinition)();
//# sourceMappingURL=utils.js.map